import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'claro' | 'escuro' | 'black';

export const THEMES: { value: Theme; label: string }[] = [
  { value: 'claro', label: 'Claro' },
  { value: 'escuro', label: 'Escuro' },
  { value: 'black', label: 'Black' },
];

function apply(theme: Theme): void {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', theme);
  }
}

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

/**
 * Tema da interface (claro / escuro / black). Persistido em localStorage
 * e aplicado como data-theme em <html>. O default é escuro (broadcast).
 */
export const useTheme = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'claro',
      setTheme: (theme) => {
        apply(theme);
        set({ theme });
      },
    }),
    {
      name: 'wiredesk-theme',
      onRehydrateStorage: () => (state) => {
        apply(state?.theme ?? 'claro');
      },
    },
  ),
);

/** Aplica o tema persistido no arranque (antes do primeiro paint). */
export function initTheme(): void {
  apply(useTheme.getState().theme);
}
